import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ABOUT_US_READ, partnerData } from "../../StaticData/aboutus";
import "./CompanyOverview.css";
import diversity_bg from "../../assets/images/diversity_bg.png";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const CompanyOverview = () => {
  return (
    <div>
      <Helmet>
        <title>Company Overview | Idexcel</title>
        <meta
          content="about us, idexcel, idexcel company overview"
          name="keywords"
        />
        <meta
          content="Idexcel is a Professional Services and Technology Solutions provider specializing in Cloud Innovations, Cloud Native Services, Data Platforms and Intelligence, Automation & AI."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="company-banner-container p-0">
          <section className="company-banner-section"></section>
        </Container>
      </motion.div>

      <section className="company-overview-section">
        <Container className="mb-5 px-xl-5 " >
          <section>
            <Row className="p-0 m-0 px-0 px-lg-4">
              <h2 className="text-center mb-4 section-title">
                Company <span className="textgrad"> Overview </span>
              </h2>
              <p className="py-1">
                Idexcel is a Professional Services and Technology Solutions
                provider specializing in
                <a
                  href="ai-banking"
                  className="text-danger textDecoration"
                >
                  {" "}
                  AI Banking
                </a>
                ,
                <a href="/enterprise-ai" className="text-danger textDecoration">
                  {" "}
                  Enterprise AI
                </a>,
                <a
                  href="/data-analytics"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Data & Analytics
                </a>
                ,
                <a
                  href="/next-gen-modernization"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Next-Gen Modernization
                </a>
                ,
                <a
                  href="/cloud-innovations"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Cloud Innovations
                </a>
                ,
                <a
                  href="/managed-cybersecurity"
                  className="text-danger textDecoration"
                >
                  {" "}
                  Managed Cybersecurity
                </a>
                . Idexcel is an Amazon Web Services (AWS) Advanced Tier Services
                Partner. We as Idexcel, are proud that for more than 20 years we
                have provided services that implement complex technologies that
                are innovative, agile and successful and have provided our
                customers with lasting value.
              </p>
              <p className="py-1">
                Our name, "Idexcel" is a representation of our core principle
                "Ideas to Excellence". We are relentlessly driven by results and
                take pride in our customer-centric engagement models. We blend
                our clients’ needs with proven delivery models and highly
                talented execution teams to deliver an exceptional customer
                experience.
              </p>
              <p className="mt-2 mb-4 fw-semibold">
                <i>
                  "Idexcel's mission is to simplify and accelerate Digital
                  transformation that empowers innovation at Speed, Trust and
                  Scale"
                </i>
              </p>
              <p className="py-1">
                Headquartered in Herndon, Virginia, Idexcel has offices and
                delivery locations in the US, Europe and Asia supporting global
                clients.
              </p>
            </Row>
          </section>
          <section className="mt-4 our-partners">
            <Row className="p-0 m-0 px-2 px-lg-4">
              <h2 className="text-center mb-4 section-title">
                Our <span className="textgrad"> Partners </span>
              </h2>
              <Row className="m-0 p-0 d-flex flex-column justify-content-center flex-md-row flex-lg-row align-items-center mt-1 mb-3">
                {partnerData.map((partner, index) => {
                  return (
                    <Col
                      key={index}
                      className="col-lg-2 col-md-4 col-6 img-wrap my-3"
                    >
                      <div className="p-2">
                        <img
                          src={partner.img}
                          alt={partner.name} // Set alt attribute to the name of the partner
                          className="d-block h-auto" // Ensures images are responsive
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Row>
          </section>
        </Container>
        <section
          className="m-0 p-0 px-xl-5 pb-0 pt-5 pt-md-5 read-more-section"
          style={{ background: "#f6f7fd" }}
        >
          <Container className="px-xl-5 px-md-0 pb-xl-4">
            <Row className="m-0 p-0 px-1 content pb-xl-5">
              <Row className="m-0 p-0 d-flex flex-column flex-md-row  flex-xl-row justify-content-between justify-content-md-around px-xl-0">
                {ABOUT_US_READ?.map((read, index) => {
                  return (
                    <Col className="m-0 p-0 col-md-5 mb-5 mb-xl-0" key={index}>
                      <div className="read-more-img">
                        <img src={read?.img} alt="about us" />
                      </div>
                      <h3 className="text-black fw-semibold mt-4 mb-4">
                        {read?.title}
                      </h3>
                      <a
                        href={read.link}
                        className="textDecoration read-more-btn border border-1 border-secondary"
                      >
                        Read More
                      </a>
                    </Col>
                  );
                })}
              </Row>
            </Row>
          </Container>
        </section>
        {/* <section className="m-0 p-0">
          <Container fluid className="p-0 m-0">
            <Container className="pb-xl-3 px-xl-0 mt-4 mt-xl-0 px-lg-0 com-overview-diversity">
              <Row className="m-0 p-0 content pt-0">
                <section className="p-0">
                  <Row className="m-0 p-0 mb-5">
                    <h2 className="text-center mb-4 section-title">
                      Diversity
                    </h2>

                    <Row className="m-0 p-0 diversity-section d-flex flex-column flex-md-row flex-xl-row">
                      <div
                        className="col-lg-6 p-0 com-overview-diversity-img"
                        style={{ background: "#f0cb74" }}
                      >
                        <img src={diversity_bg} />
                      </div>
                      <div
                        className="col-lg-6 d-flex align-items-center px-lg-5 px-xl-3  com-overview-diversity"
                        style={{ background: "#4B68F5" }}
                      >
                        <p className="text-white fs-4 fw-normal p-5 px-3 text-left">
                          Idexcel is a Minority Business Enterprise (MBE),
                          certified by the National Minority Supplier
                          Development Council Certified (NMSDC).
                        </p>
                      </div>
                    </Row>
                  </Row>
                </section>
              </Row>
            </Container>
          </Container>
        </section> */}
      </section>
    </div>
  );
};

export default CompanyOverview;
